export const types = {

  RESET_PROPS: 'RESET_PROPS',

  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_REQUEST_SUCCESS: 'LOGIN_REQUEST_SUCCESS',
  LOGIN_REQUEST_ERROR: 'LOGIN_REQUEST_ERROR',
  LOGIN_USER_RESET_PROPS: 'LOGIN_USER_RESET_PROPS',



  GET_ALL_USERS_REQUEST: 'GET_ALL_USERS_REQUEST',
  GET_ALL_USERS_SUCCESS: 'GET_ALL_USERS_SUCCESS',
  GET_ALL_USERS_ERROR: 'GET_ALL_USERS_ERROR',



  GET_USER_INFO_REQUEST: 'GET_USER_INFO_REQUEST',
  GET_USER_INFO_SUCCESS: 'GET_USER_INFO_SUCCESS',
  GET_USER_INFO_ERROR: 'GET_USER_INFO_ERROR',
  GET_ALL_ROLES_REQUEST: "GET_ALL_ROLES_REQUEST",
  GET_ALL_ROLES_SUCCESS: "GET_ALL_ROLES_SUCCESS",
  GET_ALL_ROLES_ERROR: "GET_ALL_ROLES_ERROR",


  LOGIN_PASSWORD_REQUEST: ' LOGIN_PASSWORD_REQUEST',
  LOGIN_PASSWORD_REQUEST_SUCCESS: ' LOGIN_PASSWORD_REQUEST_SUCCESS',
  LOGIN_PASSWORD_REQUEST_ERROR: 'LOGIN_PASSWORD_REQUEST_ERROR',

  ADD_ADMIN_USER_REQUEST: "ADD_ADMIN_USER_REQUEST",
  ADD_ADMIN_USER_SUCCESS: "ADD_ADMIN_USER_SUCCESS",
  ADD_ADMIN_USER__ERROR: "ADD_ADMIN_USER__ERROR",

  UPDATE_ADMIN_USER_REQUEST: "UPDATE_ADMIN_USER_REQUEST",
  UPDATE_ADMIN_USER_SUCCESS: "UPDATE_ADMIN_USER_SUCCESS",
  UPDATE_ADMIN_USER__ERROR: "UPDATE_ADMIN_USER__ERROR",

  GET_ADMIN_USER_REQUEST: "GET_ADMIN_USER_REQUEST",
  GET_ADMIN_USER_SUCCESS: "GET_ADMIN_USER_SUCCESS",
  GET_ADMIN_USER__ERROR: "GET_ADMIN_USER__ERROR",

  DEACTIVE_ADMIN_USER_REQUEST: " DEACTIVE_ADMIN_USER_REQUEST",
  DEACTIVE_ADMIN_USER_SUCCESS: " DEACTIVE_ADMIN_USER_SUCCESS",
  DEACTIVE_ADMIN_USER__ERROR: " DEACTIVE_ADMIN_USER__ERROR",

  GET_DOMAIN_REQUEST: 'GET_DOMAIN_REQUEST',
  GET_DOMAIN_SUCCESS: 'GET_DOMAIN_SUCCESS',
  GET_DOMAIN_ERROR: 'GET_DOMAIN_ERROR',




  GET_MEMBERS_REQUEST: 'GET_MEMBERS_REQUEST',
  GET_MEMBERS_SUCCESS: 'GET_MEMBERS_SUCCESS',
  GET_MEMBERS_ERROR: 'GET_MEMBERS_ERROR',

  GET_PROFILE_REQUEST: 'GET_PROFILE_REQUEST',
  GET_PROFILE_SUCCESS: 'GET_PROFILE_SUCCESS',
  GET_PROFILE_ERROR: 'GET_PROFILE_ERROR',

  ADD_DOMAIN_REQUEST: 'ADD_DOMAIN_REQUEST',
  ADD_DOMAIN_SUCCESS: 'ADD_DOMAIN_SUCCESS',
  ADD_DOMAIN_ERROR: 'ADD_DOMAIN_ERROR',


  ADD_MEMBER_REQUEST: 'ADD_MEMBER_REQUEST',
  ADD_MEMBER_SUCCESS: 'ADD_MEMBER_SUCCESS',
  ADD_MEMBER_ERROR: 'ADD_MEMBER_ERROR',

  UPDATE_PROFILE_REQUEST: 'UPDATE_PROFILE_REQUEST',
  UPDATE_PROFILE_SUCCESS: 'UPDATE_PROFILE_SUCCESS',
  UPDATE_PROFILE_ERROR: 'UPDATE_PROFILE_ERROR',

  CHANGE_PASSWORD_REQUEST: 'CHANGE_PASSWORD_REQUEST',
  CHANGE_PASSWORD_SUCCESS: 'CHANGE_PASSWORD_SUCCESS',
  CHANGE_PASSWORD_ERROR: 'CHANGE_PASSWORD_ERROR',

  GET_ALL_COMPANY_REQUEST: 'GET_ALL_COMPANY_REQUEST',
  GET_ALL_COMPANY_SUCCESS: 'GET_ALL_COMPANY_SUCCESS',
  GET_ALL_COMPANY_ERROR: 'GET_ALL_COMPANY_ERROR',

  SEND_PASSWORD_REQUEST: 'SEND_PASSWORD_REQUEST',
  SEND_PASSWORD_SUCCESS: 'SEND_PASSWORD_SUCCESS',
  SEND_PASSWORD_ERROR: 'SEND_PASSWORD_ERROR',

  SET_PASSWORD_REQUEST: 'SET_PASSWORD_REQUEST',
  SET_PASSWORD_SUCCESS: 'SET_PASSWORD_SUCCESS',
  SET_PASSWORD_ERROR: 'SET_PASSWORD_ERROR',


  SEND_VERIFICTION_REQUEST: 'SEND_VERIFICTION_REQUEST',
  SEND_VERIFICTION_SUCCESS: 'SEND_VERIFICTION_SUCCESS',
  SEND_VERIFICTION_ERROR: 'SEND_VERIFICTION_ERROR',
  SEND_VERIFICTION_RESET: 'SEND_VERIFICTION_RESET',


  REGISTER_SEND_VERIFICTION_REQUEST: 'REGISTER_SEND_VERIFICTION_REQUEST',
  REGISTER_SEND_VERIFICTION_SUCCESS: 'REGISTER_SEND_VERIFICTION_SUCCESS',
  REGISTER_SEND_VERIFICTION_ERROR: 'REGISTER_SEND_VERIFICTION_ERROR',
  REGISTER_SEND_VERIFICTION_RESET_PROPS: 'REGISTER_SEND_VERIFICTION_RESET_PROPS',


  REGISTER_REQUEST: 'REGISTER_REQUEST',
  REGISTER_REQUEST_SUCCESS: 'REGISTER_REQUEST_SUCCESS',
  REGISTER_REQUEST_ERROR: 'REGISTER_REQUEST_ERROR',
  REGISTER_USER_RESET_PROPS: 'REGISTER_USER_RESET_PROPS',


  GET_TEAM_MEMBERS_REQUEST: 'GET_TEAM_MEMBERS_REQUEST',
  GET_TEAM_MEMBERS_SUCCESS: 'GET_TEAM_MEMBERS_SUCCESS',
  GET_TEAM_MEMBERS_ERROR: 'GET_TEAM_MEMBERS_ERROR',



  GET_TEAM_PANEL_MEMBERS_REQUEST: 'GET_TEAM_PANEL_MEMBERS_REQUEST',
  GET_TEAM_PANEL_MEMBERS_SUCCESS: 'GET_TEAM_PANEL_MEMBERS_SUCCESS',
  GET_TEAM_PANEL_MEMBERS_ERROR: 'GET_TEAM_PANEL_MEMBERS_ERROR',





  CHECK_DOMAIN_REQUEST: 'CHECK_DOMAIN_REQUEST',
  CHECK_DOMAIN_SUCCESS: 'CHECK_DOMAIN_SUCCESS',
  CHECK_DOMAIN_ERROR: 'CHECK_DOMAIN_ERROR',


  DELETE_DOMAIN_REQUEST: 'DELETE_DOMAIN_REQUEST',
  DELETE_DOMAIN_SUCCESS: 'DELETE_DOMAIN_SUCCESS',
  DELETE_DOMAIN_ERROR: 'DELETE_DOMAIN_ERROR',






  UPDATE_MEMBER_REQUEST: 'UPDATE_MEMBER_REQUEST',
  UPDATE_MEMBER_SUCCESS: 'UPDATE_MEMBER_SUCCESS',
  UPDATE_MEMBER_ERROR: 'UPDATE_MEMBER_ERROR',

  DELETE_MEMBER_REQUEST: 'DELETE_MEMBER_REQUEST',
  DELETE_MEMBER_SUCCESS: 'DELETE_MEMBER_SUCCESS',
  DELETE_MEMBER_ERROR: 'DELETE_MEMBER_ERROR',

  USER_RESET_PROPS: 'USER_RESET_PROPS',

  PROFILE_RESET_PROPS: 'PROFILE_RESET_PROPS',
  DOMAIN_RESET_PROPS: 'DOMAIN_RESET_PROPS',
  MEMBER_RESET_PROPS: 'MEMBER_RESET_PROPS',
  WIZARD_RESET_PROPS: 'WIZARD_RESET_PROPS',
  CALLREPORT_RESET_PROPS: 'CALLREPORT_RESET_PROPS',
  ACCESSIBILITY_RESET_PROPS: 'ACCESSIBILITY_RESET_PROPS',


  PUSH_ACCESS_LIST: 'PUSH_ACCESS_LIST',
  EMPTY_ACCESS_LIST: 'EMPTY_ACCESS_LIST',


  SELECT_USER_BY_ADMIN: 'SELECT_USER_BY_ADMIN',
  EMPTY_SELECTED_USER_BY_ADMIN: 'EMPTY_SELECTED_USER_BY_ADMIN',


  UPDATE_STATUS_DOMAIN_REQUEST: 'UPDATE_STATUS_DOMAIN_REQUEST',
  UPDATE_STATUS_DOMAIN_SUCCESS: 'UPDATE_STATUS_DOMAIN_SUCCESS',
  UPDATE_STATUS_DOMAIN_ERROR: 'UPDATE_STATUS_DOMAIN_ERROR',

  GET_PACKAGE_LIST_BY_USER_ID_REQUEST: 'GET_PACKAGE_LIST_BY_USER_ID_REQUEST',
  GET_PACKAGE_LIST_BY_USER_ID_SUCCESS: 'GET_PACKAGE_LIST_BY_USER_ID_SUCCESS',
  GET_PACKAGE_LIST_BY_USer_ID_ERROR: 'GET_PACKAGE_LIST_BY_USer_ID_ERROR',


  ACTIVE_PACKAGE_FOR_USER_REQUEST: 'ACTIVE_PACKAGE_FOR_USER_REQUEST',
  ACTIVE_PACKAGE_FOR_USER_SUCCESS: 'ACTIVE_PACKAGE_FOR_USER_SUCCESS',
  ACTIVE_PACKAGE_FOR_USER_ERROR: 'ACTIVE_PACKAGE_FOR_USER_ERROR',


  AVAILABLE_PACKAGE_LIST_REQUEST: 'AVAILABLE_PACKAGE_LIST_REQUEST',
  AVAILABLE_PACKAGE_LIST_SUCCESS: 'AVAILABLE_PACKAGE_LIST_SUCCESS',
  AVAILABLE_PACKAGE_LIST_ERROR: 'AVAILABLE_PACKAGE_LIST_ERROR',


  GET_DOMAIN_GUID_SCRIPT_REQUEST: 'GET_DOMAIN_GUID_SCRIPT_REQUEST',
  GET_DOMAIN_GUID_SCRIPT_SUCCESS: 'GET_DOMAIN_GUID_SCRIPT_SUCCESS',
  GET_DOMAIN_GUID_SCRIPT_ERROR: 'GET_DOMAIN_GUID_SCRIPT_ERROR',

  TRANSACTION_LIST_REQUEST: 'TRANSACTION_LIST_REQUEST',
  TRANSACTION_LIST_SUCCESS: 'TRANSACTION_LIST_SUCCESS',
  TRANSACTION_LIST_ERROR: 'TRANSACTION_LIST_ERROR',
  TRANSACTION_RESET_PROPS: 'TRANSACTION_RESET_PROPS',

  TRANSACTION_LIST_ADMIN_REQUEST: 'TRANSACTION_LIST_ADMIN_REQUEST',
  TRANSACTION_LIST_ADMIN_SUCCESS: 'TRANSACTION_LIST_ADMIN_SUCCESS',
  TRANSACTION_LIST_ADMIN_ERROR: 'TRANSACTION_LIST_ADMIN_ERROR',
  TRANSACTION_ADMIN_RESET_PROPS: 'TRANSACTION_ADMIN_RESET_PROPS',

  TRANSACTION_PDF_REQUEST: 'TRANSACTION_PDF_REQUEST',
  TRANSACTION_PDF_SUCCESS: 'TRANSACTION_PDF_SUCCESS',
  TRANSACTION_PDF_ERROR: 'TRANSACTION_PDF_ERROR',
  TRANSACTION_PDF_RESET_PROPS: 'TRANSACTION_PDF_RESET_PROPS',

  PACKAGE_RESET_PROPS: 'PACKAGE_RESET_PROPS',
  UPDATE_PACKAGE_REQUEST: 'UPDATE_PACKAGE_REQUEST',
  UPDATE_PACKAGE_REQUEST_SUCCESS: 'UPDATE_PACKAGE_REQUEST_SUCCESS',
  UPDATE_PACKAGE_REQUEST_ERROR: 'UPDATE_PACKAGE_REQUEST_ERROR',


  ADD_COMPANY_REQUEST: 'ADD_COMPANY_REQUEST',
  ADD_COMPANY_SUCCESS: 'ADD_COMPANY_SUCCESS',
  ADD_COMPANY_ERROR: 'ADD_COMPANY_ERROR',

  GET_SESSION_ID_REQUEST: 'GET_SESSION_ID_REQUEST',
  GET_SESSION_ID_SUCCESS: 'GET_SESSION_ID_SUCCESS',
  GET_SESSION_ID_ERROR: 'GET_SESSION_ID_ERROR',

  GET_SETTINGS_REQUEST: 'GET_SETTINGS_REQUEST',
  GET_SETTINGS_SUCCESS: 'GET_SETTINGS_SUCCESS',
  GET_SETTINGS_ERROR: 'GET_SETTINGS_ERROR',

  UPDATE_SETTINGS_REQUEST: 'UPDATE_SETTINGS_REQUEST',
  UPDATE_SETTINGS_SUCCESS: 'UPDATE_SETTINGS_SUCCESS',
  UPDATE_SETTINGS_ERROR: 'UPDATE_SETTINGS_ERROR',


  GET_QUEUE_STRATEGIES_REQUEST: 'GET_QUEUE_STRATEGIES_REQUEST',
  GET_QUEUE_STRATEGIES_SUCCESS: 'GET_QUEUE_STRATEGIES_SUCCESS',
  GET_QUEUE_STRATEGIES_ERROR: 'GET_QUEUE_STRATEGIES_ERROR',


  GET_USER_INVOICE_REQUEST: 'GET_USER_INVOICE_REQUEST',
  GET_USER_INVOICE_SUCCESS: 'GET_USER_INVOICE_SUCCESS',
  GET_USER_INVOICE_ERROR: 'GET_USER_INVOICE_ERROR',

  GET_INVOICELIST_REQUEST: 'GET_INVOICELIST_REQUEST',
  GET_USER_INVOICES_SUCCESS: 'GET_USER_INVOICES_SUCCESS',
  GET_USER_INVOICES_ERROR: 'GET_USER_INVOICES_ERROR',

  UPLOAD_PROFILE_PHOTO_REQUEST: 'UPLOAD_PROFILE_PHOTO_REQUEST',
  UPLOAD_PROFILE_PHOTO_SUCCESS: 'UPLOAD_PROFILE_PHOTO_SUCCESS',
  UPLOAD_PROFILE_PHOTO_ERROR: 'UPLOAD_PROFILE_PHOTO_ERROR',

  GET_PROFILE_PHOTO_REQUEST: 'GET_PROFILE_PHOTO_REQUEST',
  GET_PROFILE_PHOTO_SUCCESS: 'GET_PROFILE_PHOTO_SUCCESS',
  GET_PROFILE_PHOTO_ERROR: 'GET_PROFILE_PHOTO_ERROR',

  FORGOT_PASSWORD_REQUEST: 'FORGOT_PASSWORD_REQUEST',
  FORGOT_PASSWORD_SUCCESS: 'FORGOT_PASSWORD_SUCCESS',
  FORGOT_PASSWORD_ERROR: 'FORGOT_PASSWORD_ERROR',

  UPDATE_DOMAIN_REQUEST: 'UPDATE_DOMAIN_REQUEST',
  UPDATE_DOMAIN_SUCCESS: 'UPDATE_DOMAIN_SUCCESS',
  UPDATE_DOMAIN_ERROR: 'UPDATE_DOMAIN_ERROR',


  SETTING_RESET_PROPS: 'SETTING_RESET_PROPS',
  SET_DISPLAY_SWITCH_LNG_MODAL: 'SET_DISPLAY_SWITCH_LNG_MODAL',
  CLOSE_NOTIFICATION: 'CLOSE_NOTIFICATION',
  ADD_NOTIFICATION: 'ADD_NOTIFICATION',
  SET_CHART_FILTER: 'SET_CHART_FILTER',
  SET_DOMAIN_FILTER: 'SET_DOMAIN_FILTER',


  GET_DEPARTMENTS_REQUEST: 'GET_DEPARTMENTS_REQUEST',
  GET_DEPARTMENTS_SUCCESS: 'GET_DEPARTMENTS_SUCCESS',
  GET_DEPARTMENTS_ERROR: 'GET_DEPARTMENTS_ERROR',


  CREATE_TICKET_REQUEST: 'CREATE_TICKET_REQUEST',
  CREATE_TICKET_SUCCESS: 'CREATE_TICKET_SUCCESS',
  CREATE_TICKET_ERROR: 'CREATE_TICKET_ERROR',


  GET_TICKETS_REQUEST: 'GET_TICKETS_REQUEST',
  GET_TICKETS_SUCCESS: 'GET_TICKETS_SUCCESS',
  GET_TICKETS_ERROR: 'GET_TICKETS_ERROR',


  GET_TICKET_REQUEST: 'GET_TICKET_REQUEST',
  GET_TICKET_SUCCESS: 'GET_TICKET_SUCCESS',
  GET_TICKET_ERROR: 'GET_TICKET_ERROR',

  REPLAY_TICKET_REQUEST: 'REPLAY_TICKET_REQUEST',
  REPLAY_TICKET_SUCCESS: 'REPLAY_TICKET_SUCCESS',
  REPLAY_TICKET_ERROR: 'REPLAY_TICKET_ERROR',

  GET_TICKET_ATTACHMENT_REQUEST: 'GET_TICKET_ATTACHMENT_REQUEST',
  GET_TICKET_ATTACHMENT_SUCCESS: 'GET_TICKET_ATTACHMENT_SUCCESS',
  GET_TICKET_ATTACHMENT_ERROR: 'GET_TICKET_ATTACHMENT_ERROR',


  POST_TICKET_API_RUNNER_REQUEST: 'POST_TICKET_API_RUNNER_REQUEST',
  POST_TICKET_API_RUNNER_SUCCESS: 'POST_TICKET_API_RUNNER_SUCCESS',
  POST_TICKET_API_RUNNER_ERROR: 'POST_TICKET_API_RUNNER_ERROR',


  GET_USER_CLIENT_ID_REQUEST: 'GET_USER_CLIENT_ID_REQUEST',
  GET_USER_CLIENT_ID_SUCCESS: 'GET_USER_CLIENT_ID_SUCCESS',
  GET_USER_CLIENT_ID_ERROR: 'GET_USER_CLIENT_ID_ERROR',


  GET_PACKAGE_BY_ID_REQUEST: 'GET_PACKAGE_BY_ID_REQUEST',
  GET_PACKAGE_BY_ID_SUCCESS: 'GET_PACKAGE_BY_ID_SUCCESS',
  GET_PACKAGE_BY_ID_ERROR: 'GET_PACKAGE_BY_ID_ERROR',


  GET_UPGRADABLE_PACKAGES_REQUEST: 'GET_UPGRADABLE_PACKAGES_REQUEST',
  GET_UPGRADABLE_PACKAGES_SUCCESS: 'GET_UPGRADABLE_PACKAGES_SUCCESS',
  GET_UPGRADABLE_PACKAGES_ERROR: 'GET_UPGRADABLE_PACKAGES_ERROR',


  GET_PACKAGE_SERVICE_ID_REQUEST: 'GET_PACKAGE_SERVICE_ID_REQUEST',
  GET_PACKAGE_SERVICE_ID_SUCCESS: 'GET_PACKAGE_SERVICE_ID_SUCCESS',
  GET_PACKAGE_SERVICE_ID_ERROR: 'GET_PACKAGE_SERVICE_ID_ERROR',


  GET_CLIENT_PRODUCT_REQUEST: 'GET_CLIENT_PRODUCT_REQUEST',
  GET_CLIENT_PRODUCT_SUCCESS: 'GET_CLIENT_PRODUCT_SUCCESS',
  GET_CLIENT_PRODUCT_ERROR: 'GET_CLIENT_PRODUCT_ERROR',

  GET_UPGRADE_PACKAGE_REQUEST: 'GET_UPGRADE_PACKAGE_REQUEST',
  GET_UPGRADE_PACKAGE_SUCCESS: 'GET_UPGRADE_PACKAGE_SUCCESS',
  GET_UPGRADE_PACKAGE_ERROR: 'GET_UPGRADE_PACKAGE_ERROR',

  SUPPORT_RESET_PROPS: "SUPPORT_RESET_PROPS",
  RESET_USER_PACKAGE: "RESET_USER_PACKAGE",

  SET_ACTIVE_PACKAGE: "SET_ACTIVE_PACKAGE",
  RECOGNIZE_USER_SWITCH: "RECOGNIZE_USER_SWITCH",
  SET_SIGN_OUT: "SET_SIGN_OUT",

  RESET_PROFILE: "RESET_PROFILE",
  SET_GROUPED_MESSAGES : "SET_GROUPED_MESSAGES",
  SET_USERID_CHAT: "SET_USERID_CHAT",

  SET_USER_INFO_TO_RECOGNITIONS_SUCCESS: "SET_USER_INFO_TO_RECOGNITIONS_SUCCESS",
  SET_MENU_SETTINGS: "SET_MENU_SETTINGS",
  SET_DOMAIN_FILES: "SET_DOMAIN_FILES"



}

export enum Types {
  GET_DASHBOARD_SUMMERY_ERROR = "GET_DASHBOARD_SUMMERY_ERROR",
  GET_DASHBOARD_SUMMERY_SUCCESS = "GET_DASHBOARD_SUMMERY_SUCCESS",
  GET_DASHBOARD_SUMMERY_REQUEST = "GET_DASHBOARD_SUMMERY_REQUEST",


  GET_CALL_REPORT_REQUEST = 'GET_CALL_REPORT_REQUEST',
  GET_CALL_REPORT_SUCCESS = 'GET_CALL_REPORT_SUCCESS',
  GET_CALL_REPORT_ERROR = 'GET_CALL_REPORT_ERROR',
  RESET_GET_CALL_REPORT = 'RESET_GET_CALL_REPORT',


  GET_CALL_REPORT_NAME_REQUEST = 'GET_CALL_REPORT_NAME_REQUEST',
  GET_CALL_REPORT_NAME_SUCCESS = 'GET_CALL_REPORT_NAME_SUCCESS',
  GET_CALL_REPORT_NAME_ERROR = 'GET_CALL_REPORT_NAME_ERROR',

  GET_CALL_QUEUE_REPORT_REQUEST = 'GET_CALL_QUEUE_REPORT_REQUEST',
  GET_CALL_QUEUE_REPORT_SUCCESS = 'GET_CALL_QUEUE_REPORT_SUCCESS',
  GET_CALL_QUEUE_REPORT_ERROR = 'GET_CALL_QUEUE_REPORT_ERROR',

  GET_RECORD_URL_LIST_REQUEST = "GET_RECORD_URL_LIST_REQUEST",
  GET_RECORD_URL_LIST_SUCCESS = "GET_RECORD_URL_LIST_SUCCESS",
  GET_RECORD_URL_LIST_ERROR = "GET_RECORD_URL_LIST_ERROR",


  ADD_NEW_TENANT_MEMBER_REQUEST = "ADD_NEW_TENANT_MEMBER_REQUEST",
  ADD_NEW_TENANT_MEMBER_SUCCESS = "ADD_NEW_TENANT_MEMBER_SUCCESS",
  ADD_NEW_TENANT_MEMBER_ERROR = "ADD_NEW_TENANT_MEMBER_ERROR",


  GET_AVAILABLE_INTERNAL_PHONE_REQUEST = "GET_AVAILABLE_INTERNAL_PHONE_REQUEST",
  GET_AVAILABLE_INTERNAL_PHONE_SUCCESS = "GET_AVAILABLE_INTERNAL_PHONE_SUCCESS",
  GET_AVAILABLE_INTERNAL_PHONE_ERROR = "GET_AVAILABLE_INTERNAL_PHONE_ERROR",

  UPDATE_TENANT_MEMBER_REQUEST = "UPDATE_TENANT_MEMBER_REQUEST",
  UPDATE_TENANT_MEMBER_SUCCESS = "UPDATE_TENANT_MEMBER_SUCCESS",
  UPDATE_TENANT_MEMBER_ERROR = "UPDATE_TENANT_MEMBER_ERROR",

  DELETE_TENANT_MEMBER_REQUEST = "DELETE_TENANT_MEMBER_REQUEST",
  DELETE_TENANT_MEMBER_SUCCESS = "DELETE_TENANT_MEMBER_SUCCESS",
  DELETE_TENANT_MEMBER_ERROR = "DELETE_TENANT_MEMBER_ERROR",




  GET_TENANT_MEMBER_FOR_UPDATE_TENANT_MEMBER_REQUEST = "GET_TENANT_MEMBER_FOR_UPDATE_TENANT_MEMBER_REQUEST",
  GET_TENANT_MEMBER_FOR_UPDATE_TENANT_MEMBER_SUCCESS = "GET_TENANT_MEMBER_FOR_UPDATE_TENANT_MEMBER_SUCCESS",
  GET_TENANT_MEMBER_FOR_UPDATE_TENANT_MEMBER_ERROR = "GET_TENANT_MEMBER_FOR_UPDATE_TENANT_MEMBER_ERROR",


  GET_TENANT_MEMBER_SOFT_PHONE_DETAILS_REQUEST = "GET_TENANT_MEMBER_SOFT_PHONE_DETAILS_REQUEST",
  GET_TENANT_MEMBER_SOFT_PHONE_DETAILS_SUCCESS = "GET_TENANT_MEMBER_SOFT_PHONE_DETAILS_SUCCESS",
  GET_TENANT_MEMBER_SOFT_PHONE_DETAILS_ERROR = "GET_TENANT_MEMBER_SOFT_PHONE_DETAILS_ERROR",


  SEND_SOFT_PHONE_DETAILS_TO_TENANT_MEMBER_REQUEST = "SEND_SOFT_PHONE_DETAILS_TO_TENANT_MEMBER_REQUEST",
  SEND_SOFT_PHONE_DETAILS_TO_TENANT_MEMBER_SUCCESS = "SEND_SOFT_PHONE_DETAILS_TO_TENANT_MEMBER_SUCCESS",
  SEND_SOFT_PHONE_DETAILS_TO_TENANT_MEMBER_ERROR = "SEND_SOFT_PHONE_DETAILS_TO_TENANT_MEMBER_ERROR",


  TOGGLE_TENANT_MEMBER_STATUS_REQUEST = "TOGGLE_TENANT_MEMBER_STATUS_REQUEST",
  TOGGLE_TENANT_MEMBER_STATUS_SUCCESS = "TOGGLE_TENANT_MEMBER_STATUS_SUCCESS",
  TOGGLE_TENANT_MEMBER_STATUS_ERROR = "TOGGLE_TENANT_MEMBER_STATUS_ERROR",


  GET_TENANT_WEBSITE_DOMAIN_REQUEST = "GET_TENANT_WEBSITE_DOMAIN_REQUEST",
  GET_TENANT_WEBSITE_DOMAIN_SUCCESS = "GET_TENANT_WEBSITE_DOMAIN_SUCCESS",
  GET_TENANT_WEBSITE_DOMAIN_ERROR = "GET_TENANT_WEBSITE_DOMAIN_ERROR",

  RESET_DELETE_TENANT = "RESET_DELETE_TENANT",

  SET_USER_INFO = "SET_USER_INFO"


}
